import React from 'react'
import './style.css'

const TechStack = ({ content }) => {
    return (
        <>
            <div className="our-tech-stack-main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="main-tech-stack-section-ecommerce-container">
                                <h2 className='low-top-white-heading text-center'>{content?.shortHeading}</h2>
                                <p className="main-tech-stack-section-ecommerce-title" dangerouslySetInnerHTML={{ __html: content?.mainHeading }}></p>
                                <p className="description-text-white text-center">{content?.description}</p>

                                <div className="main-tech-stack-section-ecommerce-brands">
                                    <div className="container">
                                        <div className="row justify-content-center tech-stack-section-icons-boxes">
                                            {/* col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 justify-content-center d-flex */}
                                            {content?.techStackIcons?.map((item, index) => {
                                                return <div className="tech-stack-icon-box"><img key={index} src={`/images/ecommerce-tech-stacks/${item?.image}`} width={item?.width} alt={item?.alt || "Icon Here"} className="main-tech-stack-section-ecommerce-brand-logo" /></div>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TechStack